import { mutator } from 'satcheljs';
import { onRetentionTagForItemsUpdateSuccess } from '../actions/internalActions';
import { mailStore } from 'owa-mail-store';

mutator(onRetentionTagForItemsUpdateSuccess, actionMessage => {
    const { itemIds, tag, isArchiveTag } = actionMessage;
    itemIds.forEach((itemId: string) => {
        const item = mailStore.items.get(itemId);
        // If the item has not been downloaded yet, return
        if (!item) {
            return;
        }
        if (isArchiveTag) {
            item.ArchiveTag = tag;
        } else {
            item.PolicyTag = tag;
        }
    });
});
